export const INTEGRATION_STATUSES = [
  { key: "active", label: "Active" },
  { key: "archived", label: "Archived" }
] as const;

export type IntegrationStatus = (typeof INTEGRATION_STATUSES)[number]["key"];

export const INTEGRATION_SORTS = [
  {
    key: "name_asc",
    label: "Name, A-Z"
  },
  {
    key: "name_desc",
    label: "Name, Z-A"
  },
  {
    key: "created_at_desc",
    label: "Created At, Newest First"
  },
  {
    key: "created_at_asc",
    label: "Created At, Oldest First"
  }
] as const;

export type IntegrationSort = (typeof INTEGRATION_SORTS)[number]["key"];
